<template>
  <div style="margin: 0 20px;">
    <div :style="{height:height+'px'}" class="showImageBox">
      <span class="title">{{ code }}</span>
      <el-image
        v-if="url"
        style="width: 100%;height:100%"
        :src="url"
        :preview-src-list="srcList"
        fit="scale-down">
      </el-image>
      <el-empty v-else description="暂无图片"></el-empty>
    </div>
    <div class="flex_box" v-if="imageArray.length > 0">
      <div v-for="(item,index) in imageArray" :key="index" :class="activeIndex == index ? 'borderBlue':''" class="imageBox" @click="handBoxImg(item,index)">
        <el-image
          style="width: 100px;height:100px"
          :src="item.fileUrl"
          fit="cover"></el-image>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      url: '',
      activeIndex: 0,
      srcList: []
    }
  },
  props: {
    imageArray: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: Number,
      default: () => {
        return 600
      }
    },
    code: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: {},
  watch: {
    imageArray: {
      handler (newVal) {
        if (newVal.length > 0) {
          this.url = newVal[this.activeIndex].fileUrl
          this.srcList = newVal.map(item => item.fileUrl)
        }
      },
      immediate: true,
      deep: false
    }
  },
  methods: {
    // 点击图片事件
    handBoxImg (item, index) {
      this.activeIndex = index
      this.url = this.imageArray[this.activeIndex].fileUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.pd0{
  padding: 0 !important;
}
.flex_box{
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
}
.imageBox{
  cursor: pointer;
  padding: 3px;
}
.borderBlue {
  border: solid 2px #2ea5f8;
}
.showImageBox {
  width: 100%;
  border: 1px solid rgb(220, 223, 230);
  position: relative;
}
.title{
  position: absolute;
  top: 10px;
  left: 10px;
  color: #2ea5f8;
  font-size: 30px;
  z-index: 10;
}
</style>
    
    
    